import { render, staticRenderFns } from "./CostTemplateRevenueGeneratorModal.vue?vue&type=template&id=5a20db19&scoped=true&"
import script from "./CostTemplateRevenueGeneratorModal.vue?vue&type=script&lang=js&"
export * from "./CostTemplateRevenueGeneratorModal.vue?vue&type=script&lang=js&"
import style0 from "./CostTemplateRevenueGeneratorModal.vue?vue&type=style&index=0&id=5a20db19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20db19",
  null
  
)

export default component.exports